import { getLocale } from '@actual-app/core/shared/locale';

import { useGlobalPref } from './useGlobalPref';

/**
 * The user's language code (BCP 47).
 * Contabile defaults to Italian when no preference has been set.
 */
export function useLanguage() {
  const [language] = useGlobalPref('language');
  return language || 'it-IT';
}

export function useLocale() {
  return getLocale(useLanguage());
}
